import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import {
  Row, Col, Card, Table, Button, Input, AutoComplete,
  notification, Modal, Select, Avatar, Typography, TableColumnsType,
  Checkbox, DatePicker, Drawer, Form, InputNumber, Space, Tooltip, Tag, Spin
} from "antd";

import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined, FileExcelOutlined, CalendarOutlined, SendOutlined,
  FilterOutlined, EditOutlined, ExclamationCircleOutlined, SearchOutlined,
  EyeOutlined, UserOutlined, PlusOutlined, ReloadOutlined, CloseOutlined,
  PhoneOutlined
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import ImportListModal from './components/importListModal';

const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography;
const { Item } = Form;
const { TextArea } = Input;

function RegistrationList() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get('page')) || 1;
  const limitQuery = parseInt(queryParams.get('limit')) || 20;

  // Registration list states
  const [registrationList, setRegistrationList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(limitQuery);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: queryParams.get('name') || '',
    email: queryParams.get('email') || '',
    phone_no: queryParams.get('phone_no') || '',
    father_name: queryParams.get('father_name') || '',
    village: queryParams.get('village') || '',
    district: queryParams.get('district') || '',
    occ_address: queryParams.get('occ_address') || '',
    amount: queryParams.get('amount') || '',
    dob: queryParams.get('dob') || '',
    createdAt: queryParams.get('createdAt') || '',
    payment_status: queryParams.get('payment_status') || '',
    is_send: queryParams.get('is_send') || '',
    amountMin: queryParams.get('amountMin') || '',
    amountMax: queryParams.get('amountMax') || '',
  });

  // Drawer states
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [form] = Form.useForm();
  const [txnDate, setTxnDate] = useState(null);
  const [sendMessage, setSendMessage] = useState(false);

  // Filter states
  const [showRegistrationFilter, setShowRegistrationFilter] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [isModalVisibleImportList, setIsModalVisibleImportList] = useState(false);

  // Enhanced table columns with better styling
  const columns = [
    {
      title: <Text strong style={{ color: '#7a0000' }}>#</Text>,
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 60,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Phone No</Text>,
      dataIndex: "phone_no",
      key: "phone_no",
      fixed: 'left',
      width: 140,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Name</Text>,
      dataIndex: "name",
      key: "name",
      width: 150,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Amount Pledge</Text>,
      dataIndex: "amount",
      key: "amount",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Father Name</Text>,
      dataIndex: 'father_name',
      key: 'father_name',
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>DOB</Text>,
      dataIndex: "dob",
      key: "dob",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Village</Text>,
      dataIndex: "village",
      key: "village",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>District</Text>,
      dataIndex: "district",
      key: "district",
      width: 120,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Occ Address</Text>,
      dataIndex: "occ_address",
      key: "occ_address",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Entry Date</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 120,
      sorter: true,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Payment Status</Text>,
      dataIndex: "payment_status",
      key: "payment_status",
      width: 130,
      align: 'center',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Remark</Text>,
      dataIndex: "remark",
      key: "remark",
      width: 150,
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Last Sent</Text>,
      key: "last_date",
      dataIndex: "last_date",
      width: 120,
      fixed: 'right',
    },
    {
      title: <Text strong style={{ color: '#7a0000' }}>Actions</Text>,
      key: "action",
      dataIndex: "action",
      fixed: 'right',
      width: 150,
      align: 'center',
    }
  ];

  useEffect(() => {
    const { state } = history.location;
    const restoredPage = state?.page || currentPage;
    const restoredLimit = state?.limit || limit;
    getUserList(restoredPage, restoredLimit, sortField, sortOrder, search, filters);
  }, [history.location]);

  // Drawer functions
  const showDrawer = (userId = null) => {
    if (userId) {
      setCurrentUserId(userId);
      setIsUpdateMode(true);
      fetchRegistrationDetails(userId);
    } else {
      setCurrentUserId(null);
      setIsUpdateMode(false);
      form.resetFields();
      setTxnDate(null);
    }
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setCurrentUserId(null);
    setIsUpdateMode(false);
    form.resetFields();
    setTxnDate(null);
    setSendMessage(false);
  };

  const fetchRegistrationDetails = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/registration/read/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        form.setFieldsValue(response.data.result);
        // Handle DOB properly - check for valid date
        const dobValue = response.data.result.dob;
        if (dobValue && dobValue !== '0000-00-00' && moment(dobValue).isValid()) {
          setTxnDate(dobValue);
        } else {
          setTxnDate(null);
        }
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch registration details',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };


  // Fixed RegistrationList.js - onFinish method
const onFinish = async (values) => {
  try {
    setLoading(true);
    
    // ✅ Fix: Proper date handling - send null instead of empty strings
    if (txnDate && txnDate !== '0000-00-00' && moment(txnDate).isValid()) {
      const formattedDate = moment(txnDate).format('YYYY-MM-DD');
      values.dob = formattedDate;
    }
    // Don't set dob if it's empty/invalid - let backend handle it

    values.action = sendMessage ? 'save_send' : 'save';

    if (isUpdateMode) {
      const response = await axios.patch(`${baseUrl}/registration/update/${currentUserId}`, values, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Record updated successfully!',
          placement: 'topRight'
        });
        closeDrawer();
        getUserList(currentPage, limit, sortField, sortOrder, search, filters);
      }
    } else {
      const response = await axios.post(`${baseUrl}/registration/create`, values, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        notification.success({
          message: 'Success',
          description: 'Registration added successfully!',
          placement: 'topRight'
        });
        form.resetFields();
        setTxnDate(null);
        if (!sendMessage) {
          closeDrawer();
        }
        getUserList(currentPage, limit, sortField, sortOrder, search, filters);
      }
    }
  } catch (error) {
    console.error('Form submission error:', error);
    notification.error({
      message: 'Error',
      description: error.response?.data?.message || 'Operation failed',
      placement: 'topRight'
    });
  } finally {
    setLoading(false);
  }
};

  const handleDateChange = (date, dateString) => {
    if (date) {
      const formattedDate = moment(date).format('YYYY-MM-DD');
      setTxnDate(formattedDate);
    } else {
      setTxnDate(null);
    }
  };

  async function getUserList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setLoading(true);
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/registration/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setRegistrationList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch registration data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${baseUrl}/registration/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      if (response.status === 200) {
        getUserList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
        notification.success({
          message: 'Success',
          description: 'Registration deleted successfully!',
          placement: 'topRight'
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to delete registration',
        placement: 'topRight'
      });
    }
  };

  const showDeleteConfirm = (id, userName) => {
    confirm({
      title: 'Delete Registration',
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div>
          <p>Are you sure you want to delete this registration?</p>
          {userName && (
            <div style={{ 
              background: '#fff2f0', 
              border: '1px solid #ffccc7', 
              padding: '8px 12px', 
              borderRadius: '6px',
              marginTop: '8px'
            }}>
              <Text strong style={{ color: '#cf1322' }}>Entry to be deleted:</Text>
              <br />
              <Text>{userName}</Text>
            </div>
          )}
          <p style={{ color: '#8c8c8c', fontSize: '12px', marginTop: '8px' }}>
            ⚠️ This action cannot be undone.
          </p>
        </div>
      ),
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      okButtonProps: {
        danger: true,
        style: { borderRadius: '6px' }
      },
      cancelButtonProps: {
        style: { borderRadius: '6px' }
      },
      onOk() {
        handleDelete(id);
      },
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    history.push(`?page=${current}&limit=${pageSize}`);
    getUserList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set('limit', value);
    updatedQueryParams.set('page', 1);
    history.push(`?${updatedQueryParams.toString()}`);
    getUserList(1, value);
  };

  const handleFilterChange = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value
    };
    setFilters(newFilters);
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach(key => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);
  };

  const handleSearch = () => {
    getUserList(1, limit, sortField, sortOrder, search, filters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      name: '',
      email: '',
      phone_no: '',
      father_name: '',
      village: '',
      district: '',
      occ_address: '',
      amount: '',
      dob: '',
      createdAt: '',
      payment_status: '',
      is_send: '',
      amountMin: '',
      amountMax: '',
    };
    setFilters(resetFilters);
    setSearch('');
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach(key => {
      updatedQueryParams.delete(key);
    });
    history.push(`?${updatedQueryParams.toString()}`);
    getUserList(1, limit, sortField, sortOrder, '', resetFilters);
  };

  const handleResendMessage = async (userId) => {
    Modal.confirm({
      title: 'Are you sure you want to Re-send message?',
      onOk: async () => {
        try {
          const response = await axios.patch(`${baseUrl}/registration/messageresend/${userId}`, { send: 'yes' }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          });
          if (response.status === 200) {
            getUserList(currentPage, limit, sortField, sortOrder, search, filters);
            notification.success({
              message: 'Success',
              description: 'Message sent successfully',
              placement: 'topRight',
            });
          }
        } catch (error) {
          notification.error({
            message: 'Error',
            description: "Failed to send message",
            placement: 'topRight'
          });
        }
      },
    });
  };

  const exportToExcel = async () => {
    try {
      setLoading(true);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/registration/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        const formattedData = response.data.result.map((user, index) => ({
          "Sr.No": index + 1,
          "Phone no": user.phone_no,
          "Name": user.name,
          "Amount Pledge": user.amount,
          "Father Name": user.father_name,
          "Dob": user.createdAt ? moment(user.dob).format('DD-MM-YYYY') : '-',
          "Village": user.village,
          "District": user.district,
          "Occ Address": user.occ_address,
          "Date": user.createdAt ? moment(user.createdAt).format('DD-MM-YYYY') : '-',
          "Payment Status": user.phone_no === user.user_phone_no ? "Received" : 'Pending',
          "Remark": user.remark
        }));

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Registration-list");
        XLSX.writeFile(workbook, "Registration-List.xlsx");
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to export data',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <UserOutlined style={{ color: '#fff', fontSize: '20px' }} />
                <Title level={3} style={{ margin: 0, color: '#fff' }}>
                  Registration Management
                </Title>
              </div>
            }
            extra={
              <Space size="middle">
                <Button
                  type="default"
                  icon={<FileExcelOutlined />}
                  onClick={() => setIsModalVisibleImportList(true)}
                  style={{ borderRadius: '6px' }}
                >
                  Import List
                </Button>
                {hasPermission('/registration', 'createPermission') && (
                  <Button
                    onClick={() => showDrawer()}
                    style={{
                      background: '#fff',
                      color: '#7a0000',
                      borderColor: '#fff',
                      borderRadius: '6px',
                      fontWeight: 600,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                    }}
                  >
                    Add Registration
                  </Button>
                )}
                {hasPermission('/registration', 'downloadPermission') && (
                  <Button
                    type="default"
                    icon={<FileExcelOutlined />}
                    onClick={exportToExcel}
                    style={{ borderRadius: '6px' }}
                  >
                    Export Excel
                  </Button>
                )}
              </Space>
            }
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                loading={loading}
                scroll={{ x: 'max-content' }}
                bordered
                size="middle"
                title={() => (
                  <div style={{ marginBottom: '16px' }}>
                    <Row gutter={[16, 16]} align="middle">
                      <Col>
                        <Button
                          icon={<FilterOutlined />}
                          onClick={() => setShowRegistrationFilter(!showRegistrationFilter)}
                          style={{
                            borderRadius: '6px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {showRegistrationFilter ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                      </Col>
                      {showRegistrationFilter && (
                        <Col flex="auto">
                          <div style={{
                            padding: '16px',
                            background: '#f8f9fa',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef'
                          }}>
                            <Row gutter={[12, 12]}>
                              <Col span={6}>
                                <Input
                                  placeholder="Search by phone"
                                  value={filters.phone_no}
                                  onChange={e => handleFilterChange('phone_no', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Input
                                  placeholder="Search by name"
                                  value={filters.name}
                                  onChange={e => handleFilterChange('name', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Input
                                  placeholder="Father name"
                                  value={filters.father_name}
                                  onChange={e => handleFilterChange('father_name', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Input
                                  placeholder="Village"
                                  value={filters.village}
                                  onChange={e => handleFilterChange('village', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Input
                                  placeholder="District"
                                  value={filters.district}
                                  onChange={e => handleFilterChange('district', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Input
                                  placeholder="Occ Address"
                                  value={filters.occ_address}
                                  onChange={e => handleFilterChange('occ_address', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Input
                                  placeholder="Single Amount"
                                  value={filters.amount}
                                  onChange={e => handleFilterChange('amount', e.target.value)}
                                  style={{ borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <DatePicker
                                  className="filter_dob"
                                  format="DD-MM-YYYY"
                                  value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null}
                                  onChange={(date, dateString) => handleFilterChange('dob', dateString)}
                                  placeholder="DOB Date"
                                  style={{ width: '100%', borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <DatePicker
                                  className="filter_dob"
                                  format="DD-MM-YYYY"
                                  value={filters.createdAt ? moment(filters.createdAt, 'DD-MM-YYYY') : null}
                                  onChange={(date, dateString) => handleFilterChange('createdAt', dateString)}
                                  placeholder="Entry Date"
                                  style={{ width: '100%', borderRadius: '6px' }}
                                />
                              </Col>
                              <Col span={6}>
                                <Select
                                  placeholder="Payment Status"
                                  value={filters.payment_status}
                                  onChange={value => handleFilterChange('payment_status', value)}
                                  style={{ width: '100%', borderRadius: '6px' }}
                                  allowClear
                                >
                                  <Option value="">All Status</Option>
                                  <Option value="Pending">Pending</Option>
                                  <Option value="Received">Received</Option>
                                </Select>
                              </Col>
                              <Col span={6}>
                                <Select
                                  placeholder="Message Status"
                                  value={filters.is_send}
                                  onChange={value => handleFilterChange('is_send', value)}
                                  style={{ width: '100%', borderRadius: '6px' }}
                                  allowClear
                                >
                                  <Option value="">All Messages</Option>
                                  <Option value="0">Not Sent</Option>
                                  <Option value="1">Sent</Option>
                                </Select>
                              </Col>
                              <Col span={12}>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                  <Input
                                    placeholder="Min Amount"
                                    value={filters.amountMin}
                                    onChange={(e) => handleFilterChange('amountMin', e.target.value)}
                                    style={{ borderRadius: '6px' }}
                                    type="number"
                                  />
                                  <span style={{ color: '#666', fontWeight: 500 }}>to</span>
                                  <Input
                                    placeholder="Max Amount"
                                    value={filters.amountMax}
                                    onChange={(e) => handleFilterChange('amountMax', e.target.value)}
                                    style={{ borderRadius: '6px' }}
                                    type="number"
                                  />
                                </div>
                              </Col>
                              <Col span={24}>
                                <Space>
                                  <Button
                                    icon={<SearchOutlined />}
                                    onClick={handleSearch}
                                    style={{ borderRadius: '6px', background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}
                                  >
                                    Search
                                  </Button>
                                  <Button
                                    icon={<ReloadOutlined />}
                                    onClick={handleResetFilters}
                                    style={{ borderRadius: '6px' }}
                                  >
                                    Reset All Filters
                                  </Button>
                                </Space>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Row style={{ marginTop: '16px' }}>
                      <Col>
                        <Space align="center">
                          <Text strong>Records per page:</Text>
                          <Select
                            value={limit}
                            onChange={handleLimitChange}
                            style={{ width: 80, borderRadius: '6px' }}
                          >
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                            <Option value={250}>250</Option>
                            <Option value={300}>300</Option>
                          </Select>
                        </Space>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={registrationList.map((user, index) => {
                  const isMatch = user.phone_no === user.user_phone_no;
                  
                  return {
                    key: (limit * (currentPage - 1)) + index + 1,
                    phone_no: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag
                          color={isMatch ? 'success' : 'default'}
                          style={{
                            borderRadius: '12px',
                            padding: '4px 12px',
                            fontWeight: '500'
                          }}
                        >
                          {user.phone_no}
                        </Tag>
                        {isMatch && (
                          <div style={{ fontSize: '10px', color: '#52c41a', marginTop: '2px' }}>
                            ✓ Verified
                          </div>
                        )}
                      </div>
                    ),
                    name: (
                      <div>
                        <Text strong style={{ color: '#262626' }}>{user.name}</Text>
                      </div>
                    ),
                    father_name: (
                      <Text style={{ color: '#595959' }}>{user.father_name || '-'}</Text>
                    ),
                    amount: (
                      <Text strong style={{ color: '#7a0000' }}>
                        ₹{user.amount ? Number(user.amount).toLocaleString() : '0'}
                      </Text>
                    ),
                    dob: (
                      <Text>{user.dob ? moment(user.dob).format('DD MMM YYYY') : '-'}</Text>
                    ),
                    village: (
                      <Text style={{ color: '#595959' }}>{user.village || '-'}</Text>
                    ),
                    district: (
                      <Text style={{ color: '#595959' }}>{user.district || '-'}</Text>
                    ),
                    occ_address: (
                      <Text style={{ color: '#595959' }}>{user.occ_address || '-'}</Text>
                    ),
                    payment_status: (
                      <div style={{ textAlign: 'center' }}>
                        <Tag
                          color={isMatch ? 'success' : 'warning'}
                          style={{ borderRadius: '12px', fontWeight: '500' }}
                        >
                          {isMatch ? "Received" : 'Pending'}
                        </Tag>
                      </div>
                    ),
                    remark: (
                      <Text style={{ color: '#595959' }}>{user.remark || '-'}</Text>
                    ),
                    createdAt: (
                      <Text>
                        {user.createdAt && user.createdAt !== "0000-00-00" 
                          ? moment(user.createdAt).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    last_date: (
                      <Text>
                        {user.last_date && user.last_date !== '0000-00-00'   
                          ? moment(user.last_date).format('DD MMM YYYY') 
                          : '-'}
                      </Text>
                    ),
                    action: (
                      <Space size="small">
                        {hasPermission('/registration', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<EditOutlined />}
                            onClick={() => showDrawer(user.id)}
                            style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', borderRadius: '4px' }}
                          >Edit</Button>
                        )}
                        {hasPermission('/registration', 'deletePermission') && (
                          <Button
                            danger
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => showDeleteConfirm(user.id, user.name)}
                          >Delete</Button>
                        )}
                        {hasPermission('/registration', 'editPermission') && (
                          <Button
                            size="small"
                            icon={<SendOutlined />}
                            onClick={() => handleResendMessage(user.id)}
                            style={{ borderRadius: '4px' }}
                          >
                            {user.is_send === 1 ? 'Re-send' : 'Send'}
                          </Button>
                        )}
                      </Space>
                    )
                  };
                })}
                pagination={{
                  ...pagination,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                  showSizeChanger: false,
                  style: { marginTop: '16px' }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            </div>
          </Card>
        </Col>
      </Row>

      {/* Enhanced Drawer for Add/Edit */}
      <Drawer
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {isUpdateMode ? <EditOutlined style={{ color: 'white', fontSize: '18px' }} /> : <UserOutlined style={{ color: 'white', fontSize: '18px' }} />}
            </div>
            <div>
              <Title level={4} style={{ margin: 0, color: 'white' }}>
                {isUpdateMode ? 'Update Registration' : 'Add Registration'}
              </Title>
             
            </div>
          </div>
        }
        width={window.innerWidth > 1200 ? 800 : window.innerWidth > 768 ? 600 : '90%'}
        open={drawerVisible}
        onClose={closeDrawer}
        closable={false}
        bodyStyle={{
          padding: 0,
          background: '#f8f9fa'
        }}
        headerStyle={{
          background: '#7a0000',
          border: 'none'
        }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={closeDrawer}
            style={{ color: 'white' }}
          />
        }
        destroyOnClose
      >
        <div style={{ height: '100%', padding: '24px' }}>
          <Spin spinning={loading}>
            <Card
              bordered={false}
              style={{
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            >
              <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
                requiredMark={false}
                style={{ maxWidth: '100%' }}
              >
                <Row gutter={[20, 16]}>
                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Phone Number</Text>}
                      name="phone_no"
                      rules={[
                        { required: true, message: 'Please enter phone number' },
                        { pattern: /^\d{10,12}$/, message: 'Phone must be 10-12 digits!' }
                      ]}
                    >
                      <Input
                        prefix={<PhoneOutlined style={{ color: '#7a0000' }} />}
                        placeholder="Enter phone number"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>
                  
                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Full Name</Text>}
                      name="name"
                      rules={[{ required: true, message: 'Please enter name' }]}
                    >
                      <Input
                        prefix={<UserOutlined style={{ color: '#7a0000' }} />}
                        placeholder="Enter full name"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Father's Name</Text>}
                      name="father_name"
                    >
                      <Input
                        placeholder="Enter father's name"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Date of Birth</Text>}
                    >
                      <DatePicker
                        onChange={handleDateChange}
                        value={txnDate && txnDate !== "0000-00-00" ? moment(txnDate) : null}
                        format="DD-MM-YYYY"
                        placeholder="Select date of birth"
                        style={{ width: '100%', borderRadius: '8px', height: '40px' }}
                        suffixIcon={<CalendarOutlined style={{ color: '#7a0000' }} />}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Village</Text>}
                      name="village"
                    >
                      <Input
                        placeholder="Enter village"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>District</Text>}
                      name="district"
                    >
                      <Input
                        placeholder="Enter district"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Occupation Address</Text>}
                      name="occ_address"
                    >
                      <Input
                        placeholder="Enter occupation address"
                        style={{ borderRadius: '8px', height: '40px' }}
                      />
                    </Item>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Item
                      label={<Text strong>Amount Pledge</Text>}
                      name="amount"
                    >
                      <InputNumber
                        placeholder="Enter amount"
                        style={{ width: '100%', borderRadius: '8px', height: '40px' }}
                        formatter={value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/₹\s?|(,*)/g, '')}
                        min={0}
                      />
                    </Item>
                  </Col>

                  {isUpdateMode && (
                    <Col xs={24} sm={12}>
                      <Item
                        label={<Text strong>Payment Status</Text>}
                        name="payment_status"
                      >
                        <Select
                          placeholder="Select payment status"
                          style={{ borderRadius: '8px', height: '40px' }}
                        >
                          <Option value="Pending">
                            <Space>
                              <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#faad14' }}></div>
                              Pending
                            </Space>
                          </Option>
                          <Option value="Received">
                            <Space>
                              <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#52c41a' }}></div>
                              Received
                            </Space>
                          </Option>
                        </Select>
                      </Item>
                    </Col>
                  )}

                  <Col xs={24}>
                    <Item
                      label={<Text strong>Remark</Text>}
                      name="remark"
                    >
                      <TextArea
                        placeholder="Enter any remarks or notes"
                        rows={3}
                        style={{ borderRadius: '8px' }}
                      />
                    </Item>
                  </Col>
                </Row>

                <div style={{
                  marginTop: '32px',
                  paddingTop: '24px',
                  borderTop: '1px solid #f0f0f0',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '12px'
                }}>
                  <Button
                    onClick={closeDrawer}
                    size="large"
                    style={{ borderRadius: '8px', minWidth: '100px' }}
                  >
                    Cancel
                  </Button>
                  
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    onClick={() => setSendMessage(false)}
                    style={{
                      borderRadius: '8px',
                      minWidth: '100px',
                      background: '#7a0000'
                    }}
                    loading={loading}
                  >
                    {isUpdateMode ? 'Update' : 'Save'}
                  </Button>

                  {!isUpdateMode && (
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      onClick={() => setSendMessage(true)}
                      style={{
                        borderRadius: '8px',
                        minWidth: '120px',
                        background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                        border: 'none'
                      }}
                      loading={loading}
                      icon={<SendOutlined />}
                    >
                      Save & Send
                    </Button>
                  )}
                </div>
              </Form>
            </Card>
          </Spin>
        </div>
      </Drawer>

      {/* Import Modal */}
      <ImportListModal
        isVisible={isModalVisibleImportList}
        onClose={() => setIsModalVisibleImportList(false)}
        onSuccess={() => {
          setIsModalVisibleImportList(false);
          getUserList();
        }}
      />

      {/* Image Modal */}
      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        centered
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%', borderRadius: '8px' }}
        />
      </Modal>
    </div>
  );
}

export default RegistrationList;